import PATHS from '../constants';

function fetchBlogTags() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    return fetch(PATHS.BLOG_TAGS, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchBlogTags;